import React from 'react';
import img1 from "../../assets/images/home/good.svg"; // Ensure the image path is correct
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Slide images
const slides = [
  { img: img1 },
  { img: img1 },
  { img: img1 },
  { img: img1 },
  { img: img1 },
  { img: img1 },
];

// Custom Left Arrow
const PrevArrow = ({ onClick }) => {
  return (
    <div
      className="custom-arrow left-arrow"
      onClick={onClick}
      style={{
        position: 'absolute',
        left: '-30px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        cursor: 'pointer',
        background: "#C6AFFF",
        width:"30px",
        height:"30px",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        borderRadius: "50%"
      }}
    >
      {/* Your custom SVG or arrow icon */}
      <i class="fa-solid fa-arrow-left"></i>
    </div>
  );
};

// Custom Right Arrow
const NextArrow = ({ onClick }) => {
  return (
    <div
      className="custom-arrow right-arrow"
      onClick={onClick}
      style={{
        position: 'absolute',
        right: '-30px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        cursor: 'pointer',
        background: "#C6AFFF",
        width:"30px",
        height:"30px",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        borderRadius: "50%"
      }}
    >
      {/* Your custom SVG or arrow icon */}
      <i class="fa-solid fa-arrow-right"></i>
    </div>
  );
};

const HomeSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <NextArrow />, // Use custom next arrow
    prevArrow: <PrevArrow />, // Use custom previous arrow
    arrows: true, // Ensure arrows are enabled
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className=" relative w-[90%] lg:w-full mx-auto">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className=" ">
            <img
              src={slide.img}
              alt={`Slide ${index}`}
              className="p-6 rounded-lg"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeSlider;
